class FeaturedCollectionsSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.scrollbar = null;
    this.prevButton = null;
    this.nextButton = null;
  }

  connectedCallback() {
    // Wait for Swiper library to be loaded
    if (typeof Swiper === 'undefined') {
      setTimeout(() => this.connectedCallback(), 100);
      return;
    }

    // Small delay to ensure DOM is ready
    setTimeout(() => this.initSlider(), 50);

    this.rangeInput = this.closest("section").querySelector('input[type="range"]');
    this.slideByRange();
  }

  initSlider() {
    const swiperElement = this.querySelector('.featured-collections__slider');

    // Query scrollbar from parent section since it's outside the custom element
    const section = this.closest('.featured-collections');

    // Query navigation buttons
    this.prevButton = this.querySelector('[data-nav-prev]');
    this.nextButton = this.querySelector('[data-nav-next]');

    if (!swiperElement) {
      console.error('Featured Collections: Swiper element not found');
      return;
    }

    this.slider = new Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      grabCursor: true,
      navigation: {
        prevEl: this.prevButton,
        nextEl: this.nextButton,
      },
      breakpoints: {
        990: {
          slidesPerView: 4,
          spaceBetween: 25
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 25
        }
      },
      on: {
        init: (swiper) => {
          this.updateScrollbarCircle(swiper.progress);
        },
        progress: (swiper, progress) => {
          this.updateScrollbarCircle(progress);
        },
        slideChange: (swiper) => {
          this.updateScrollbarCircle(swiper.progress);
        },
        touchMove: (swiper) => {
          this.updateScrollbarCircle(swiper.progress);
        },
      },
    });
  }

  updateScrollbarCircle(progress) {
    // Calculate the position as a percentage (0 to 100)
    const percentage = Math.max(0, Math.min(100, progress * 100));
    this.rangeInput.value = Math.round(percentage * 100) / 100;
  }

  slideByRange() {
    if (this.rangeInput) {
      this.rangeInput.addEventListener('input', (event) => {
        const value = event.target.value;
        const wrapperWidth = this.slider.virtualSize;
        const containerWidth = this.slider.width;
        // total scrollable distance
        const maxTranslate = wrapperWidth - containerWidth;
        const translateValue = (value / 100) * maxTranslate;
        this.slider.setTranslate(`-${translateValue}`);
      });
    }
  }

  disconnectedCallback() {
    if (this.slider) {
      this.slider.destroy(true, true);
      this.slider = null;
    }
  }
}

customElements.define('featured-collections-slider', FeaturedCollectionsSlider);
